import { useMount } from 'react-use';

/**
 * Scrolls the window to the top when the component first mounts
 */
export const useScrollToTopOnMount = () => useMount(() => window.scrollTo(0, 0));
